// extracted by mini-css-extract-plugin
module.exports = {"container":"SignPad_container__21Q_Q","wrapper":"SignPad_wrapper__d9I_E","buttons":"SignPad_buttons__2OUms","east":"SignPad_east__1VNap","btn":"SignPad_btn__1AvYe"};